import React from 'react'
import {Link, useLocation} from 'react-router-dom'
import {financialStatusTypes} from 'app/utilities'
import {deliveryTypes, fulfillmentStatusTypes} from 'app/constant'
import clsx from 'clsx'

interface Props {
  id: string
  financialStatus: string
  orderDeliveryMethod: string
  fulfillmentStatus: string
}

const FulfillmentAction: React.FC<Props> = ({
  id,
  financialStatus,
  orderDeliveryMethod,
  fulfillmentStatus,
}) => {
  const {state} = useLocation()
  if (
    financialStatus === financialStatusTypes.paid ||
    financialStatus === financialStatusTypes.partiallyRefunded
  ) {
    return (
      <div className='row gx-xl-8 float-end'>
        <div className='col-auto'>
          <Link
            id='btnCreatePostage'
            type='button'
            className={clsx('btn explore-btn-outline rounded-2 btn-primary-active')}
            to={`/orders/${id}/fulfillments/manual`}
            state={state}
          >
            Fulfill Item
          </Link>
        </div>
        {fulfillmentStatus !== fulfillmentStatusTypes.readyToFulfill && (
          <>
            {orderDeliveryMethod === deliveryTypes.ship && (
              <div className='col-auto'>
                <Link
                  id='CreateCarrier'
                  type='button'
                  className='btn btn-primary'
                  to={`/orders/${id}/fulfillments/shipping`}
                  state={state}
                >
                  Create carrier postage directly
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    )
  }
  return null
}

export default FulfillmentAction
